/**
 * Reads our own JWT's payload to surface `guest`, `access`, and `admin` claims
 * to the UI. We never verify the signature here — the server is authoritative.
 * This is purely so the client can decide what to render before its next call.
 */
export interface TokenClaims {
  guest: boolean;
  access: boolean;
  admin: boolean;
}

const EMPTY: TokenClaims = { guest: false, access: false, admin: false };

function base64UrlDecode(input: string): string {
  const padding = '='.repeat((4 - (input.length % 4)) % 4);
  const b64 = (input + padding).replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new TextDecoder().decode(bytes);
}

export function readTokenClaims(token: string | null | undefined): TokenClaims {
  if (!token) return EMPTY;
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return EMPTY;
    const payload = JSON.parse(base64UrlDecode(parts[1])) as Record<string, unknown>;
    return {
      guest: payload.guest === true,
      access: payload.access === true,
      admin: payload.admin === true,
    };
  } catch {
    return EMPTY;
  }
}
